import { Component, Input, OnInit } from '@angular/core';
import { BrandingConfigurationService } from '@ptl/brand';
import { LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure } from '@ptl/account-management';
import { ReducerUtilityService } from '../../../shared/utility-services/reducer-utility.service';
import { Clipboard } from '@angular/cdk/clipboard';
//import * as moment from 'moment';
import moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EntitlementsHelperService } from '@ptl/account-management';
import { BooleanInput } from '@ptl/global-components';

@Component({
    selector: 'app-passive-referrals',
    templateUrl: './passive-referrals.component.html',
    styleUrls: ['./passive-referrals.component.scss'],
    standalone: false
})

export class PassiveReferralsComponent implements OnInit {

  linkCopied: boolean = false;
  doesNotHaveNpn: boolean = false; 

  @Input() producerUrl: string;
  @Input() headingText: string = "Hello Agent {firstName} {lastName}!"; 
  @Input() headingSubtext: string = "This is your annual OEP personalized URL:";
  @Input() buttonSubtext: string = "Feel free to bookmark your personal page for easy access and sharing.";
  @Input() buttonText: string = "Copy URL";
  @Input() urlCopiedMessage: string = "URL Copied to Clipboard!";
  @Input() planYear: number;
  @Input() @BooleanInput() isForcedDisabled: boolean;
  @Input() disabledMessage: string;

  constructor(
    private brandService: BrandingConfigurationService,
    private reducerUtilityService: ReducerUtilityService,
    private clipboard: Clipboard,
    private snackBar: MatSnackBar,
    private entitlementsHelperService: EntitlementsHelperService
  ) {} 

  async ngOnInit() {
    const loginInfo: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);
    let curBrandCode = this.brandService.getCurrentBrand().cookieBrandCode?.toUpperCase();
    const firstName: string = loginInfo?.basicUserInfo?.firstName;
    const lastName: string = loginInfo?.basicUserInfo?.lastName;
    const selectedAgency = await this.entitlementsHelperService.getSelectedAgencyPromise();

    this.headingText = this.headingText.replace('{firstName}', `${firstName}`).replace('{lastName}', `${lastName}`);
    this.generateStaticURL(curBrandCode, loginInfo);
    
    this.doesNotHaveNpn = (!selectedAgency.npnNo && !loginInfo.userInfo.npnNo) ? true : false;

  }



generateStaticURL(curBrandCode, loginInfo) {
      /****
     * EX: "https://shop.bluecrossmnonline.com/producer-url?agentCode=13597389&agencyNumber=0002597985&year=2025&brandName=MINCR&userId=AGT2016222&EmailTypePreference=PRODUCER_URL"
     ****/
    const agentName = loginInfo.userInfo.firstName + "_" + loginInfo.userInfo.lastName;
    const agentCode = loginInfo.userInfo.agencyInfo.selectedAgencies.INDIVIDUAL.agentACSId || loginInfo.userInfo.agentId;
    const agencyNumber = loginInfo.userInfo.agencyInfo.selectedAgencies.INDIVIDUAL.agencyId;
    // moment().month() has a value of 0-11, 0 being January, 11 being December
    // the plan year will default to the current year if the month is BEFORE July. Any month that is July or later will default to the following plan year. 
    // ex: June 2025, Plan Year: 2025 | July 2025, Plan Year: 2026
    const defaultPlanYear = moment().month() > 5 ? moment().year() + 1 : moment().year();
    const year = this.planYear ? this.planYear : defaultPlanYear;

    const userId = loginInfo.userId
    this.producerUrl = this.producerUrl.replace('{agentName}', `${agentName}`);
    this.producerUrl = this.producerUrl.replace('{agentCode}', `${agentCode}`);
    this.producerUrl = this.producerUrl.replace('{agencyNumber}', `${agencyNumber}`);
    this.producerUrl = this.producerUrl.replace('{year}', `${year}`);
    this.producerUrl = this.producerUrl.replace('{curBrandCode}', `${curBrandCode}`);
    this.producerUrl = this.producerUrl.replace('{userId}', `${userId}`); 
}

copyToClipboard(){
  this.clipboard.copy(this.producerUrl)
  const alertDuration = 1000; // ms

  this.snackBar.open(`${this.urlCopiedMessage}`, 'OK', {
    duration: alertDuration,
    panelClass: 'positive-panel-class'
  });

}

}
